<template>
  <div class="template_pop" v-if="message.show">
    <div>
      <div class="el-icon-close" @click="close" />
      <div class="template_pop_title">操作确认</div>
      <div class="template_pop_content">
        {{ message.tips }}
      </div>
      <div class="template_pop_btn">
        <el-button type="primary" size="small" @click="submit">确认</el-button>
        <el-button type="primary" size="small" @click="close" plain
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$parent.message = {
        show: false,
      }
    },
    submit() {
      this.message.callback && this.message.callback()
    },
  },
}
</script>
<style lang="scss" scoped>
.template_pop_content {
  margin: 20px 0 10px 20px;
  font-weight: 600;
  font-size: 14px;
  span {
    color: var(--color_basic);
  }
}
</style>
